import { css } from '@emotion/css';

export const styPopupDeleteText = css`
  text-align: left;
  margin-top: 32px;
  font-size: 14px;
`;

export const styPopupDeleteBtn = css`
  display: flex;
  justify-content: flex-end;
  margin-top: 32px;
`;
